import { z } from "zod";
export const AgencyBrandingConsistencyV1Schema = z
    .object({
    schemaVersion: z.literal("agency-branding-consistency.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalAgencyBrandingConsistency(recordedAt) {
    return AgencyBrandingConsistencyV1Schema.parse({
        schemaVersion: "agency-branding-consistency.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=agency-branding-consistency.js.map